module.exports = __webpack_public_path__ + "static/img/on.22502230.gif";